module.exports = __webpack_public_path__ + "static/media/sadek.f3203a25.png";